// extracted by mini-css-extract-plugin
export default {"page":"AudioEditing_page__ALEaA","head":"AudioEditing_head__dsqRS","editor":"AudioEditing_editor__Uaitx"};